import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useViewerAvailableModes } from './useViewerAvailableModes';
import { useViewerModeStore } from '../store/useViewerModeStore';
import { useViewerTheaterModeStore } from '../store/useViewerTheaterModeStore';

export const useViewerTheaterMode = () => {
  const theaterModeStore = useViewerTheaterModeStore();
  const { isTheaterMode } = storeToRefs(theaterModeStore);
  const { isMobile } = useViewerAvailableModes();
  const { isLogsMode } = storeToRefs(useViewerModeStore());

  const isTheaterModeAvailable = computed(() => !isMobile.value && !isLogsMode.value);
  const isTheaterModeEnabled = computed(() => isTheaterModeAvailable.value && isTheaterMode.value);

  return {
    theaterModeStore,
    isTheaterMode,
    isTheaterModeAvailable,
    isTheaterModeEnabled,
  };
};
